import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MyTable from '../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { LogActionsAPI } from '../../../../API/log_action';

import { unoTheme, headerSearch } from '../../../../assets/styles/unoTheme'

import moment from 'moment';
import { useDispatch } from 'react-redux';
import allActions from '../../../../actions';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  green: {
    color: 'green'
  },
  red: {
    color: 'red',
  },
  headerSearch: headerSearch,
  inputSearch: {
    width: "300px",
    background: "white"
  },
  toStickyHeader: {
    display: 'flex',
    height: '100%',
  },
  rightDivBackdrop: {
    backgroundColor: 'white',
    position: 'absolute',
    opacity: 0.7,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .progress': {
      color: unoTheme.mainColor
    }
  },
}));

const LIMIT = 30;

const ROLE_LABELS = {
  ROLE_MANAGER: 'Gestor',
  ROLE_SUBMANAGER: 'Subgestor',
  ROLE_VIEWER: 'Visualizador',
};

const toApiDate = (date) => date && date.isValid() ? date.format('YYYY-MM-DD') : undefined;

/**
 * Logins de usuários de clientes (equipe interna excluída no backend)
 * @param {string} search nome ou CPF
 * @param {object} selectedClient cliente do autocomplete
 * @param {moment} dateStart
 * @param {moment} dateEnd
 */
export default function AccessHistory({ search, selectedClient, dateStart, dateEnd }) {

  const classes = useStyles();
  const dispatch = useDispatch();

  const [accessHistoryLogs, setAccessHistoryLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);

  const startDate = toApiDate(dateStart);
  const endDate = toApiDate(dateEnd);

  async function doGetAccessHistoryLogs(page) {
    dispatch(allActions.innerLoadActions.setInnerLoad({
      show: true,
      loadMessage: 'Carregando acessos...'
    }));

    const response = await LogActionsAPI.getAccessHistoryLogs({
      clientId: selectedClient ? selectedClient.id : undefined,
      startDate,
      endDate,
      search: search || undefined,
      offset: (page - 1) * LIMIT,
      limit: LIMIT,
    });

    if (response.success && response.body) {
      const accessHistoryLogsData = response.body.rows;
      setAccessHistoryLogs(accessHistoryLogsData);
      setCount(response.body.totalRows);

      if (accessHistoryLogsData.length > 0) {
        dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
      } else {
        dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, emptyMessage: 'Não existem acessos' }));
      }
    } else {
      console.error("RESPONSE ERROR: ", response.body);
      setAccessHistoryLogs([]);
      setCount(0);
      dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
    }
  }

  const handleChange = (value) => {
    const newPage = page + value;
    setPage(newPage);
    doGetAccessHistoryLogs(newPage);
  };

  // Filtro novo volta para a primeira página
  useEffect(() => {
    setPage(1);
    doGetAccessHistoryLogs(1);
  }, [search, selectedClient, startDate, endDate]);

  return (
    <div className={classes.root}>
      <div class={'defaultScrollWithHeaderContent'}>
        <MyTable
          pagination={accessHistoryLogs.length > 0}
          itemspage={LIMIT}
          currentPage={page}
          totalitems={count}
          handlePage={handleChange}
          stickyHeader
          nofixed={true}
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCell align="left">Data de Login</TableCell>
              <TableCell align="left">Nome do usuário</TableCell>
              <TableCell align="left">Perfil</TableCell>
              <TableCell align="left">Cliente</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {accessHistoryLogs.map((row, index) => (
              <TableRow key={'log-access-' + index}>
                <TableCell align="left" style={{ color: unoTheme.mainColor }}>{moment(row.login_date).format("DD/MM/YYYY - HH:mm:ss")}</TableCell>
                <TableCell align="left">{row.username.toUpperCase()}</TableCell>
                <TableCell align="left">{ROLE_LABELS[row.role] || row.role || '-'}</TableCell>
                <TableCell align="left">{row.client_label || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </MyTable>
      </div>
    </div>
  );
}